import React, { useEffect, useRef, useState } from "react";
import { VolumeX, Volume2 } from "lucide-react";

const OPTIONS = [
  { label: "10 minutes", minutes: 10 },
  { label: "1 hour", minutes: 60 },
  { label: "1 day", minutes: 1440 },
  { label: "Until unmuted", minutes: null },
];

export function MuteMenu({ userId, mute, onMute, onUnmute }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  if (mute) {
    return (
      <button onClick={() => onUnmute(userId)} data-testid={`mod-mute-${userId}`} title="Unmute" className="icon-btn rounded p-1.5 sm:p-0.5 hover:bg-red-500/20 hover:text-red-300">
        <Volume2 size={10} />
      </button>
    );
  }
  return (
    <span ref={ref} className="relative">
      <button onClick={() => setOpen((v) => !v)} data-testid={`mod-mute-${userId}`} title="Mute" aria-expanded={open} className="icon-btn rounded p-1.5 sm:p-0.5 hover:bg-red-500/20 hover:text-red-300">
        <VolumeX size={10} />
      </button>
      {open && (
        <div data-testid={`mute-menu-${userId}`} className="absolute right-0 top-5 z-20 w-36 overflow-hidden rounded-md border border-white/10 bg-[#0b0f14] py-1 text-xs normal-case tracking-normal shadow-xl">
          <div className="px-3 py-1 text-[10px] uppercase tracking-widest text-slate-500">Mute for</div>
          {OPTIONS.map((o) => (
            <button key={o.label} onClick={() => { setOpen(false); onMute(userId, o.minutes); }} data-testid={`mute-opt-${o.minutes ?? "forever"}-${userId}`} className="block w-full px-3 py-1.5 text-left text-slate-200 hover:bg-red-500/20 hover:text-red-200">
              {o.label}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}

export function muteLabel(mute) {
  if (!mute) return null;
  if (!mute.muted_until) return "muted";
  const d = new Date(mute.muted_until);
  const sameDay = d.toDateString() === new Date().toDateString();
  return `muted until ${d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}${sameDay ? "" : " " + d.toLocaleDateString([], { day: "numeric", month: "short" })}`;
}
